<script setup lang="ts">
import { ref,watch } from 'vue';
import { useRouter } from 'vue-router';
import { pickAllowedPath } from '@/router/router';
import { Button } from '@/components/shadcnui/button';
import { Input } from '@/components/shadcnui/input'
import { Label } from '@/components/shadcnui/label'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/shadcnui/card';
import { useLogin } from '@/composable/useLogin';
import { useUserStore } from '@/store/useUserStore';

const router = useRouter();
const { onLogin } = useLogin();
const UserStore = useUserStore();
const account = ref('');
const password = ref('');
const iserrorMessage = ref(false);

const handleLogin = async () => {
  await onLogin(account.value, password.value);
  if (UserStore.isLoggedIn) {
    // 로그인 성공 후 허용된 경로로 리다이렉트
    UserStore.startSession(5); // 세션 시작 (5시간)
    router.push(pickAllowedPath(UserStore.menus ?? []));
   } else {
    iserrorMessage.value = true;
  }
};
watch(() => account.value, () => {
  iserrorMessage.value = false;
});
watch(() => password.value, () => {
  iserrorMessage.value = false;
})
</script>

<template>
  <div class="flex h-screen flex-col items-center justify-center bg-background">
    <div class="w-1/4 mb-6 text-3xl font-bold text-center">
      릴리즈 시스템
    </div>
    <Card class="w-1/4">
      <CardHeader>
        <CardTitle>Login</CardTitle>
        <hr class="my-2" />
      </CardHeader>
      <CardContent>
        <div class="grid w-full items-center gap-4">
          <div class="flex flex-col space-y-1.5">
            <Label for="account">ID</Label>
            <Input id="account" v-model="account" @keyup.enter="handleLogin" />
          </div>
          <div class="flex flex-col space-y-1.5">
            <div class="flex items-center">
              <Label for="password">Password</Label>
            </div>
            <Input id="password" type="password" v-model="password" @keyup.enter="handleLogin" />
            <p v-if="iserrorMessage" class="text-sm text-red-500">
              아이디 또는 비밀번호를 확인하세요.
            </p>
            <Button class="mt-6" @click="handleLogin">
              Login
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  </div>
</template>